import "leaflet/dist/leaflet.css";
import { Suspense } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useTranslation } from "react-i18next";

const mosqueIcon = L.divIcon({
  className: "custom-mosque-icon", // You can add custom styles in CSS if needed
  html: `
    <svg width="50" height="55" viewBox="0 0 512 512" xml:space="preserve" >
      <path fill="#C19A6B" stroke="#8B5A2B" stroke-width="0" d="M256,0C160.798,0,83.644,77.155,83.644,172.356c0,97.162,48.158,117.862,101.386,182.495 C248.696,432.161,256,512,256,512s7.304-79.839,70.97-157.148c53.228-64.634,101.386-85.334,101.386-182.495 C428.356,77.155,351.202,0,256,0z M256,231.921c-32.897,0-59.564-26.668-59.564-59.564s26.668-59.564,59.564-59.564 c32.896,0,59.564,26.668,59.564,59.564S288.896,231.921,256,231.921z"/>
    </svg>
  `,
  iconSize: [30, 40], // Adjust size
  iconAnchor: [15, 40], // Centering the icon
});

const MosqueMap = ({ mosques, onSelectMosque }) => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<p style={{ textAlign: "center" }}>{t(`loading`)}</p>}>
      <MapContainer
        center={[21.4225, 39.8262]}
        zoom={14}
        style={{ height: "600px", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {mosques.map(
          (mosque) =>
            mosque.location?.coordinates?.length === 2 && (
              <Marker
                key={mosque._id}
                position={[
                  mosque.location.coordinates[0],
                  mosque.location.coordinates[1],
                ]}
                eventHandlers={{
                  click: () => {
                    if (typeof onSelectMosque === "function") {
                      onSelectMosque(mosque._id);
                    }
                  },
                }}
                icon={mosqueIcon}
              >
                <Popup>
                  <strong>{mosque.name}</strong>
                  <br />
                  {mosque.address}
                </Popup>
              </Marker>
            ),
        )}
      </MapContainer>
    </Suspense>
  );
};

export default MosqueMap;
